var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    color: "#07272D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_423051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.866413 4.01101C0.7803 4.06275 0.709008 4.13584 0.659442 4.22322C0.609876 4.3106 0.583716 4.4093 0.583496 4.50976V5.45476C0.583716 5.55522 0.609876 5.65392 0.659442 5.7413C0.709008 5.82867 0.7803 5.90177 0.866413 5.95351L1.74141 6.47851C1.83214 6.53302 1.93599 6.56181 2.04183 6.56181C2.14767 6.56181 2.25152 6.53302 2.34225 6.47851L3.50016 5.78434V4.18018L2.04183 3.30518L0.866413 4.01101Z",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04168 5.05519L0.65918 4.22394",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0415 5.05515L3.49984 4.18015",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0415 5.05518V6.56309",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.18018V5.78434L4.65792 6.47851C4.74864 6.53302 4.85249 6.56181 4.95833 6.56181C5.06418 6.56181 5.16802 6.53302 5.25875 6.47851L6.13375 5.95351C6.21986 5.90177 6.29115 5.82867 6.34072 5.7413C6.39029 5.65392 6.41645 5.55522 6.41667 5.45476V4.50976C6.41645 4.4093 6.39029 4.3106 6.34072 4.22322C6.29115 4.13584 6.21986 4.06275 6.13375 4.01101L4.95833 3.30518L3.5 4.18018Z",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95833 5.05515L3.5 4.18015",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9585 5.05519L6.341 4.22394",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9585 5.05518V6.56309",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32442 1.53183C2.23831 1.58356 2.16702 1.65666 2.11745 1.74404C2.06788 1.83142 2.04172 1.93012 2.0415 2.03058V3.30516L3.49984 4.18016L4.95817 3.30516V2.03058C4.95795 1.93012 4.93179 1.83142 4.88222 1.74404C4.83266 1.65666 4.76137 1.58356 4.67525 1.53183L3.80025 1.00683C3.70953 0.95232 3.60568 0.923523 3.49984 0.923523C3.394 0.923523 3.29015 0.95232 3.19942 1.00683L2.32442 1.53183Z",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49969 2.576L2.11719 1.74475",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.576L4.8825 1.74475",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.18016V2.57599",
    stroke: "currentColor",
    strokeWidth: 0.622502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_423051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(0 0.242676)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitCenter);
export default __webpack_public_path__ + "static/media/profitCenter.8ff9693fe97df8c10a3c8cc6bfecf7cf.svg";
export { ForwardRef as ReactComponent };